import { render, staticRenderFns } from "./artpack_request.vue?vue&type=template&id=0f42f64a&"
import script from "./artpack_request.vue?vue&type=script&lang=js&"
export * from "./artpack_request.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports